import * as ts from "../common/Translator";
import SearcherWindowTemplate from "../compiled-templates/SearcherWindowTemplate";
import {nextId, registerOnWindowResize} from "../common/NamaCommon";
import {_calcWindowDimensions, updateCheckBoxes} from "./search/SearcherWindow";
import {attachNextAndPreviousFocus} from "../routing/EditPresenter";
import {isMobileDevice} from "../common/GUIUtilities";
import {deleteSelectedRows} from "../grid/GridEventsController";

export class NamaWindowBtnData {
    /**
     *
     * @param {string} btnTitle
     * @param {function} btnAction
     */
    constructor(btnTitle, btnAction) {
        let that = this;
        that.btnTitle = btnTitle;
        that.btnAction = btnAction;
    }
}

export class NamaKendoWindow {

    /**
     *
     * @param {string} title
     * @param {NamaWindowBtnData} okBtnData
     * @param {NamaWindowBtnData} cancelBtnData
     */
    constructor(title, okBtnData, cancelBtnData, width, withoutBtns, fullScreen, inQuestionListWidget) {
        let that = this;
        that.title = title;
        that.okBtnData = okBtnData;
        that.cancelBtnData = cancelBtnData;
        that.elementId = nextId();
        that.inQuestionListWidget = inQuestionListWidget;
        let window = $(SearcherWindowTemplate({elementId: that.elementId, translateId: ts.translateId}));
        window.find(".searchInput").remove();
        window.find("#insertRowAtEnd").remove();
        window.find("#insertRowsAtEndByOrder").remove();
        window.find("#insertRow").remove();
        window.find("#searchParams").remove();
        if (!that.inQuestionListWidget) {
            window.find("#selectAll").remove();
            window.find("#deleteAll").remove();
            window.find("#deleteSelected").remove();
        }
        if (withoutBtns)
            window.find(".searcherWindowBtns").remove();
        that.window = window;
        that.content = window.find("#grid");
        if (isMobileDevice())
            width = "100%";
        that.width = width || "75%";
        that.fullScreen = fullScreen;
    }

    showWindow(callBack, notModal) {
        let that = this;
        if(that.isOpen())
            return;
        that.window.find("#ok").kendoButton({
            click: e => {
                that.okBtnData.btnAction();
            }
        });
        that.window.find("#cancel").kendoButton({
            click: e => {
                that.closeWindow(e);
            }
        });
        that.window.find("#selectAll").kendoButton({
            click: e => {
                updateCheckBoxes(true, that.window.find("#grid"));
            }
        });
        that.window.find("#deleteAll").kendoButton({
            click: e => {
                let grid = that.window.find("#grid");
                updateCheckBoxes(true, grid);
                deleteSelectedRows(that.gridWidget, that.gridWidget._kendoGrid());
            }
        });
        that.window.find("#deleteSelected").kendoButton({
            click: e => {
                deleteSelectedRows(that.gridWidget, that.gridWidget._kendoGrid());
            }
        });
        let modal_ = true;
        if (notModal)
            modal_ = false;
        let kWindowDim = _calcWindowDimensions();
        /**
         * @type {kendo.ui.Window}
         */
        that.kendowWindow = that.window.kendoWindow({
            minWidth: kWindowDim.width / 2,
            resizable: true,
            width: that.width,
            title: ts.translateId(that.title),
            visible: false,
            modal: modal_,
            actions: [
                "Pin",
                "Minimize",
                "Maximize",
                "Close"
            ],
            close: function (e) {
                that.closeWindow(e);
            }
        }).data("kendoWindow");
        if (that.fullScreen)
            that.kendowWindow.open().maximize();
        else
            that.kendowWindow.open().center();
        setTimeout(() => that.content.find(":input:enabled:visible:first").focus(), 500);
        attachNextAndPreviousFocus(that.content);
            setTimeout(() => {
                if (that.doCallBackFirstly && callBack)
                    callBack();
                that.calcGridHeight();
                registerOnWindowResize(that.windowRootElement()[0], (e) => {
                    that.calcGridHeight();
                });
                if (!that.doCallBackFirstly && callBack)
                    callBack();
            }, 750);
    }

    windowRootElement() {
        return $("#window" + this.elementId);
    }

    calcGridHeight() {
        let that = this;
        let window = that.windowRootElement();
        let windowHeight = window.height();
        let footerHeight = window.find(".searcherWindowBtns").height();
        let height = windowHeight - footerHeight - 10;
        let grid = window.find("#grid");
        grid.height(height);
        if (grid.find("#splitter").length) {
            let pageHeaderHeight = grid.find(".page-top-header").height();
            grid.find("#splitter").height(height - pageHeaderHeight);
            grid.find("#splitter").addClass("windowInnerSplitter");
        }
    }

    addDataWidget(widget) {
        let that = this;
        that.content.append(widget);
    }

    closeWindow(e) {
        let that = this;
        if (that.cancelBtnData.btnAction)
            that.cancelBtnData.btnAction(e);
        that.window.data("kendoWindow").destroy();
    }

    isOpen() {
        let wnd = this.window.data("kendoWindow");
        return wnd ? wnd.element.is(":visible") : false;
    }

    rootElement() {
        return this.window;
    }
}